import { render, staticRenderFns } from "./BlockExplorerLink.vue?vue&type=template&id=606700b2&"
import script from "./BlockExplorerLink.vue?vue&type=script&lang=js&"
export * from "./BlockExplorerLink.vue?vue&type=script&lang=js&"
import style0 from "./BlockExplorerLink.vue?vue&type=style&index=0&id=606700b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports